var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 226,
    viewBox: "0 0 158 226",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79 0C35.3243 0 0 35.3243 0 79C0 98.6372 5.64286 117.033 15.9129 133.623C26.6343 151.003 40.7414 165.9 51.5757 183.28C56.88 191.744 60.7171 199.644 64.78 208.786C67.7143 214.993 70.0843 225.714 79 225.714C87.9157 225.714 90.2857 214.993 93.1071 208.786C97.2829 199.644 101.007 191.744 106.311 183.28C117.146 166.013 131.253 151.116 141.974 133.623C152.357 117.033 158 98.6372 158 79C158 35.3243 122.676 0 79 0Z",
    fill: "#A7B4CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMarker);
export default __webpack_public_path__ + "static/media/icon-marker.826bb1667bbc66a6ac2006b00a5c3780.svg";
export { ForwardRef as ReactComponent };